import React, { Component, Fragment } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { hot } from 'react-hot-loader';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import '../../scss/app.scss';
import Router from './Router';
import store from './store';
import ScrollToTop from './ScrollToTop';
import AuthProvider from '../../shared/components/auth/withAuth';
import { LoadScript } from '@react-google-maps/api';

class App extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      loaded: false
    };
    this.versionCheckInterval = null;
  }

  componentDidMount() {
    var self = this;

    // Page load listener
    window.addEventListener('load', function() {
      self.setState({ loading: false });
      setTimeout(function() {
        self.setState({ loaded: true });
      }, 500);
    });

    // Initial version fetch
    fetch('/meta.json', { cache: 'no-store' })
      .then(function(res) { return res.json(); })
      .then(function(meta) {
        if (meta && meta.version) {
          self.checkAppVersion(meta.version);
        }
      })
      .catch(function(err) {
        console.log('Initial version fetch failed:', err);
      });
  }

  componentWillUnmount() {
    if (this.versionCheckInterval) {
      clearInterval(this.versionCheckInterval);
    }
  }

  checkAppVersion(currentVersion) {
    var self = this;

    this.versionCheckInterval = setInterval(function() {
      fetch('/meta.json', { cache: 'no-store' })
        .then(function(res) { return res.json(); })
        .then(function(meta) {
          if (meta && meta.version && meta.version !== currentVersion) {
            console.log('New version detected, reloading...');
            window.location.reload(true); // hard reload to bust cache
          }
        })
        .catch(function(err) {
          console.log('Version check failed:', err);
        });
    }, 60000); // check every 30 seconds
  }

  render() {
    var loaded = this.state.loaded;
    var loading = this.state.loading;

    return (
      <Provider store={store}>
        <LoadScript googleMapsApiKey="AIzaSyBEYB3e7_LMx9R5aEx3y8w99Cv2s3XJy_o">
          <BrowserRouter>
            <ScrollToTop>
              <Fragment>
                {!loaded && (
                  <div className={'load' + (loading ? '' : ' loaded')}>
                    <div className="load__icon-wrap">
                      <svg className="load__icon">
                        <path fill="#9600BF" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                      </svg>
                    </div>
                  </div>
                )}
                <div>
                  <Router />
                </div>
              </Fragment>
            </ScrollToTop>
          </BrowserRouter>
        </LoadScript>
      </Provider>
    );
  }
}

export default hot(module)(App);
